const state = {
  currentClass: null,
  classes: undefined,
  students: undefined,
  inviteToast: undefined,
  classDeleteToast: undefined
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/classes/state.js